module.exports = __webpack_public_path__ + "img/phone-icon.54a27041.svg";